<template>
    <div class="admin-up d-flex justify-content-between">
        <div class="admin-up--thumb">
            <i class="p-sm-1 p-md-3 fa " :class="ticketTypeAndActive()"></i>
            <div v-if="readTicketAttribute('premium') !== ''"
                 :class="readTicketAttribute('premium')">
                <div class="point"></div>
                <div class="point"></div>
                <div class="point"></div>
                <div class="point"></div>
                <div class="point"></div>
            </div>
            <div v-if="readTicketAttribute('recommended') !== ''"
                 :class="readTicketAttribute('recommended')">

            </div>
            <div v-if="readTicketAttribute('on_sale') !== ''"
                 :class="readTicketAttribute('on_sale')"></div>
        </div>
        <div class="event-ticket--crud d-flex justify-content-between">
            <button class="m-0 btn-info btn-floating waves-effect"
                    v-on:click="editTicket()"
                    :class="{'active':ticket.edit_mode == true}">
                <i class="fa fa-pencil-alt"></i></button>
            <!--jump to ticket page-->
<!--            <button class="m-0 ml-3 ml-md-2 btn-accent btn-floating waves-effect"-->
<!--                    v-on:click="ultraEditTicket()">-->
<!--                <i class="fa fa-cog"></i></button>-->
            <a class="m-0 ml-3 ml-md-2 btn-accent btn-floating waves-effect"
               :href="ticket_edit_url+'/'+ticket.id"
            target="_blank">
                <i class="fa fa-cog"></i>
            </a>

            <button class="m-0 ml-3 ml-md-2 btn-warning btn-floating waves-effect"
                    :class="{
                        'disabled': !ticketIsActive()
                    }"
                    v-on:click="deleteTicketConfirm()">
                <i class="fa fa-trash"></i></button>
        </div>
    </div>
</template>

<script>
	// add imports here

	//call method of parent
	// this.$parent.$options.methods.someParentMethod(data)

	export default {
		props: ['ticket', 'ticket_types', 'methods_available','current_ticket','ticket_edit_url'],
		created() {
			// console.log('this.methodsRef',this.methods_available);
		},
		destroyed() {
		},
		mounted() {
		    // console.log('ticket',this.ticket)
		},
		data() {
			return {}
		},
		methods: {
            ticketIsActive(){
                return this.ticket.status === 'active'
            },
			isActive(ticket) {
				return ticket.status === 'active' ? 'bg-info' : 'disabled-color';
			},
			ticketType(type) {
				let ticketType = '',
					types = this.ticket_types;

				if (typeof types !== 'undefined' && types !== null) {

					if (types.hasOwnProperty(type)) {
						ticketType = 'icon-tilt-' + types[type].icon;
					}
					else if (type === 'total') {
						ticketType = 'fa fa-home';
					}
					else {
						console.error(type + ' not found in ', types);
						ticketType = 'fa fa-exclamation';
					}
				}
				else {
					console.error('ticket type not defined. type was ' + type);
				}
				return ticketType;
			},

			ticketTypeAndActive(ticket_types) {
				let active = this.isActive(this.ticket);
				let type = this.ticketType(this.ticket.ticket_type, ticket_types);
				return active + ' ' + type;
			},
			readTicketAttribute(type) {
				return this.methods_available.readTicketAttribute(this.ticket, type);
			},
			deleteTicketConfirm() {
                if(!this.ticketIsActive()){
                    return;
                }
				this.$emit('event', {
					action: 'delete',
					items: {
						ticket: this.ticket
					}
				});
			},
			ultraEditTicket() {
				this.$emit('event', {
					action: 'ultra-edit',
					items: {
						ticket: this.ticket
					}
				});
			},
			editTicket() {
				this.$emit('event', {
					action: 'edit',
					items: {
						value: 'item-' + this.ticket.id,
						ticket: this.ticket
					}
				});
				// return this.methods_available.editTicket(this.ticket,'item-'+this.ticket.id);
			}
		},
		computed: {

        }
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/pages/ticketing/EventTicketThumbnail.vue?6fdfaeef